/**
 * Product analytics (Phase 56, committee R-15). PostHog is initialised by the snippet in public/index.html and exposed as
 * `window.posthog`; this helper is the only place the app talks to it, so the funnel can be renamed or switched off here.
 * Never throws, never blocks rendering, no personal data: events carry placement/role/language only.
 *
 * Landing funnel events:
 *   landing_cta_click        { placement }   primary "Create your account" (hero / how / footer / header / menu)
 *   landing_secondary_click  { placement }   zero-commitment path ("Model a holding")
 *   landing_calculator_used  {}              first interaction with the holding model on this page view
 *   landing_faq_open         { index }       an FAQ item expanded
 *   landing_language         { to }          language switched on the landing page
 *   register_started         {}              the register form was shown
 *   register_completed       { role }        an account was created
 */
export function track(event, props) {
  try {
    const ph = typeof window !== "undefined" ? window.posthog : null;
    if (ph && typeof ph.capture === "function") ph.capture(event, props || {});
  } catch {
    /* analytics must never affect the product */
  }
}

/** Fire an event at most once per page view (e.g. "calculator used"). */
export function trackOnce(flag, event, props) {
  if (flag.current) return;
  flag.current = true;
  track(event, props);
}
